<template>
    <div class="document-record mt-2">
    <v-form v-model="documentInstanceForm"> <!-- ToEdit -->
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <!-- Change lg to 9 if another component is placed on the right  -->
        <div class="text-right mx-4 my-2">
        </div>
        <v-card class="mx-4 my-4">
            <v-card-title>
              Custom Documents
            </v-card-title>
            <v-row class="mx-4">
                <v-col cols="12" md="4">
                  <template>
                    <v-select
                        v-model="documentType"
                        :items="documentTypes"
                        small-chips
                        outlined
                        color="primary"
                        label="Select Document Type"
                        hide-details
                        dense
                        background-color="transparent"
                        item-value="id"
                        item-text="document_name"
                        class="mb-4 rounded-input"
                    ></v-select>
                  </template>
                </v-col>

                <v-col cols="12" md="2">
                  <v-btn
                    v-if="documentType"
                    @click="createDialog = true"
                    color="primary"
                    id="create-document"
                  >
                    Create
                  </v-btn>
                </v-col>
            </v-row>

            <intract-data-table
              v-if="documentType"
              :headers="headers"
              :endpoint="documentInstancesEndpoint"
              :filter-fields="{}"
              ref="documentInstancesTable"
            >
              <template v-slot:item.actions="{ item }" justify="center">
                <v-btn text color='primary' @click="handleEditClick(item)">
                  Edit
                </v-btn>
                <v-btn text color='red' @click="deletingInstanceId = item.id; showDeleteConfirmationDialog = true">
                  Delete
                </v-btn>
                <v-btn text color='primary' @click="handleViewClick(item)">
                  View
                </v-btn>
              </template>
              <template v-slot:item.full_name="{ item }" justify="center">
                <span class="font-weight-medium">{{ item.student.full_name }}</span>
              </template>
              <template v-slot:item.classroom="{ item }" justify="center">
                <v-chip outlined small color="primary">{{ item.student.room ? item.student.room.sections : '-' }}</v-chip>
              </template>
               <template v-slot:item.created="{ item }" justify="center">
                <span>{{ moment(item.created).format('lll') }}</span>
              </template>
            </intract-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Document Instance Dialog Box -->
    <DocumentInstanceDialog
      @closeDialog="closeDialog()"
      :dialog="createDialog"
      :selectedDocumentType="documentType ? documentType : null"
      :formFields="headers"
      :is_editing="is_editing"
      :selectedDocumentInstance="selectedDocumentInstance"
    >
    </DocumentInstanceDialog>

    <DeleteConfirmationDialog 
      :visible="showDeleteConfirmationDialog"
      :title="`Are you sure you want to delete this document?`"
      description="You cannot undo this action"
      @deleteObject="deleteDocumentInstance"
    />

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" >
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
    </v-form>
  </div> 
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import DocumentInstanceDialog from '@components/templating/DocumentInstanceDialog.vue';
import IntractDataTable from "@components/widgets/generics/IntractDataTable.vue";
import DeleteConfirmationDialog from '@components/widgets/dialogs/DeleteConfirmationDialog';
import moment from "moment";

export default {
  name: "ViewDocuments",
  components: {
    DocumentInstanceDialog,
    IntractDataTable,
    DeleteConfirmationDialog
  },
  data() {
    return {
      documentType: null,
      is_editing: false,
      selectedDocumentInstance: null,
      showDeleteConfirmationDialog: false,
      deletingInstanceId: null,
      documentInstanceForm:false,
      moment: moment,
      headers: [
        {
          text: 'Student',
          align: 'left',
          value: 'full_name'
        },
        {
          text: 'Classroom',
          align: 'center',
          value: 'classroom'
        },
        {
          text: 'Created',
          align: 'center',
          value: 'created'
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions'
        }
      ],
      createDialog: false,
      documentTypes: null,
      documentInstances: null,
      snackbar: {
        visible: false,
        text: "",
        color: "dark",
      },
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser","isLoading", "currentInstitution"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
    // can uncomment and use for detailed data in the datatable
    // documentTypeHeaders(){
    //   let documentTypeDetails = this.documentTypes.find(documentType => documentType.id == this.documentType)
    //   let sampleData = JSON.parse(documentTypeDetails.sample_context)
    //   let dynamicHeaders = [];
    //   Object.keys(sampleData).forEach(key => {
    //     dynamicHeaders.push({
    //       text: key.replaceAll('_', ' '),
    //       align: "center",
    //       value: `data.${key}`
    //     })
    //   })
    //   return [
    //     ...dynamicHeaders,
    //     ...this.headers
    //   ]
    // },

    documentInstancesEndpoint(){
      return Helper.addUrlParams(endpoints.documentInstances,[
        `template_document_type=${this.documentType}`
      ]);
    }
  },
  methods: {
    ...mapActions(["setLoading"]),

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    closeDialog(){
      this.createDialog = false;
      this.$refs.documentInstancesTable.getAllItems();
      if(this.is_editing)
        this.is_editing = false;
    },

    async getAllDocumentTypes(){
      this.documentTypes = await api.call(
        this.apiEssentials,
        endpoints.documentTypes
      );
    },

    async handleViewClick(instanceContext) {
      var url = endpoints.documentInstances + instanceContext.id + "/view/";
      var temp_doc_type = null
      for(var i=0; i<this.documentTypes.length; i++){
        if(this.documentTypes[i].id == this.documentType){
          temp_doc_type = this.documentTypes[i]
        }
      }
      var body = {
        institution: this.currentInstitution.id,
        data: JSON.stringify(instanceContext),
        template_document_type: temp_doc_type,
      }
      var response = await api.call(this.apiEssentials, url, api.Methods.GET, body);
      if(response){
        const blob = this.dataURItoBlob(response);
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      }
    },

    async handleEditClick(instanceContext){
      this.selectedDocumentInstance = instanceContext;
      this.is_editing = true;
      this.createDialog = true;
    },

    async deleteDocumentInstance(confirm){
      if(confirm){
        const url = endpoints.documentInstances + this.deletingInstanceId + "/"
        const response = await api.call(this.apiEssentials, url, api.Methods.DELETE);
        if(response){
          this.deletingInstanceId = null
          this.$refs.documentInstancesTable.getAllItems();
        }
      }
      this.showDeleteConfirmationDialog = false;
      this.deletingInstanceId = null
    },

    dataURItoBlob(dataURI) {
      const byteString = window.atob(dataURI);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
          int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: 'application/pdf' });
      return blob;
    },
  },
  created() {
    this.getAllDocumentTypes();
  },
};
</script>